import { ref } from 'vue'

/**
 * 全局"智能客服抽屉"开关状态。模块级 ref → 侧栏入口与抽屉组件共享同一份
 * (同 useAuthModal 的写法)。抽屉本身挂在 AppLayout,任意页面都能唤起。
 */
const open = ref(false)
// 每次"请求展示"自增。即使抽屉已打开(可能正最小化或被拖到角落),组件也据此
// 重新展开 + 居中 —— 否则 open 已是 true,再点侧栏不触发组件里的 watch(点了没反应)。
const showRequest = ref(0)

export function useSupport() {
  return {
    open,
    showRequest,
    openSupport() {
      open.value = true
      showRequest.value++
    },
    closeSupport() {
      open.value = false
    },
    toggleSupport() {
      if (open.value) {
        open.value = false
      } else {
        open.value = true
        showRequest.value++
      }
    }
  }
}
